<script>
// Custom components
import PageHeader from "@/components/page-header";
import hotelIntentEditDrawer from "@/components/superAdmin/videoBot/hotelIntentEditDrawer.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import Drawer from "@/components/drawer";

export default {
  page: {
    title: "Master Intent List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Hotel Intent List",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Hotel Intent List",
          active: true,
        },
      ],
      tableData: [],
      hotels: [],
      isDataLoading: false,
      is_btn_loading: false,
      hotelId: "",
      hotelName: "",
      language: "English",
      shortName: "en_US",
      selected: "all",
      isBtnLoading: false,
      sortedbyASC: true,
      injectObj: {
        session_id: "",
        text: "",
        hotel_id: "",
      },
      media: "",
      addLoading: false,
      addEditIntent: false,
      updateValue: "",
    };
  },
  components: {
    PageHeader,
    Drawer,
    hotelIntentEditDrawer,
  },
  computed: {
    ...authComputed,
    intentProps() {
      return {
        isEdit: this.isEdit,
        updateValue: this.updateValue,
        isEditable: this.isEditable,
        hotelId: this.hotelId,
        hotelName: this.hotelName,
      };
    },
  },
  mounted() {
    this.getListOfIntents();
  },
  watch: {
    $route(to, from) {
      this.getListOfIntents();
    },
  },

  methods: {
    // Get list of all intents
    async getListOfIntents() {
      let tempIntent = [];

      this.isDataLoading = true;
      await UserService.getIntentsList().then((response) => {
        tempIntent = response.intentList;
      });

      if (this.$route.query.hotel != undefined) {
        this.selected = this.$route.query.hotel;
        this.injectObj.hotel_id = this.$route.query.hotel;
        localStorage.setItem("temp_hotel_id", this.injectObj.hotel_id);

        this.shortName =
          this.$route.query.lang != undefined
            ? this.$route.query.lang
            : "en_US";

        this.language =
          this.shortName == "en_US"
            ? "English"
            : this.shortName == "es_US"
            ? "Spanish"
            : "French";

        await UserService.getVideoChatHotelDetails(
          this.selected + "?language=" + this.shortName
        ).then((result) => {
          this.hotelId = result.hotel_id;
          this.hotelName = result.hotel_name;

          delete result.hotel_id;
          delete result.hotel_name;

          tempIntent.map((item) => {
            if (result[item.intent_name]) {
              if (
                item.intent_name == result[item.intent_name].name &&
                result[item.intent_name].name != "undefined"
              ) {
                result[item.intent_name].utterances = item.utterances;
                result[item.intent_name].intentId = item.id;
                result[item.intent_name].intent_name = item.intent_name;
                result[item.intent_name].more_status = false;
              }
            }
          });

          let tempResult = [];
          for (const key in result) {
            tempResult.push(result[key]);
          }

          this.tableData = tempResult;
          this.tableData.sort((x, y) =>
            x["intent_name"] < y["intent_name"] ? -1 : 1
          );
        });
      } else {
        this.hotelName = "";

        this.selected = this.$route.query.hotel;
        tempIntent.map((item) => {
          item.more_status = false;
        });

        this.tableData = tempIntent;
        this.tableData.sort((x, y) =>
          x["intent_name"] < y["intent_name"] ? -1 : 1
        );
      }
      this.isDataLoading = false;
    },

    hotelSelector() {
      if (this.selected != "") {
        this.$router.push({
          path: "/video-bot",
          query: {
            hotel: this.selected,
          },
        });
      }
    },

    async deployBot() {
      this.isBtnLoading = true;
      await UserService.deployBot()
        .then(() => {
          this.isBtnLoading = false;
          this.createError = true;
        })
        .catch((error) => {
          this.isBtnLoading = false;
          this.createError = true;
          errorHandler(error);

          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    sortList(sortBy) {
      if (this.sortedbyASC) {
        this.tableData.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
        this.sortedbyASC = false;
      } else {
        this.tableData.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
        this.sortedbyASC = true;
      }
    },

    InjectTesting(text) {
      this.injectObj.session_id = localStorage.getItem("temp_session_id");
      this.injectObj.text = text;
      this.injectObj.hotel_id = localStorage.getItem("temp_hotel_id");
      this.$refs["inject_testing_modal"].show();
    },

    InjectText() {
      this.addLoading = true;
      localStorage.setItem("temp_session_id", this.injectObj.session_id);
      localStorage.setItem("temp_hotel_id", this.injectObj.hotel_id);
      this.injectObj.language= this.$route.query.lang
      UserService.injectStream(this.injectObj).then((result) => {
        this.addLoading = false;
        if (result.message == "Injection Failed") {
          Middleware.notification(result.message, "danger");
        } else {
          Middleware.notification(result.message, "success");
        }
      });
    },

    editIntent(data) {
      this.isEdit = true;
      this.updateValue = data;
      this.addEditIntentDrawer();
    },

    addEditIntentDrawer() {
      if (this.addEditIntent === true) {
        this.isEdit = false;
        this.updateValue = "";
      }
      this.addEditIntent = !this.addEditIntent;
    },

    intentAddedUpdated(data, isEdit) {
      this.addEditIntent = true;
      this.getListOfIntents();
      this.addEditIntentDrawer();
    },

    saveAndAddNewIntent(data) {
      this.tableData.push(data);
      this.addEditIntentDrawer();
    },

    redirectBack() {
      // Go back one step in the browser history
      this.$router.go(-1);
    },

    mediaTest(data) {
      this.media = data;
      this.$refs["media_testing_modal"].show();
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="
        this.hotelName + ' Hotel in ' + language + ' language Intent List'
      "
      :items="items"
      text="Add New"
      :isButton="false"
    />

    <div class="row">
      <div class="col-md-3 d-flex align-items-start mb-3">
        <img
          :src="require('../../../assets/images/flags/' + shortName + '.jpg')"
          :alt="language"
          class="img-fluid"
        />
      </div>
      <div class="col-md-9 float-end">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="button"
          @click="redirectBack"
        >
          Go Back
        </b-button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th @click="sortList('intent_name')">Intent &#8597;</th>
                <th class="w-400">Utterances</th>
                <th class="w-500">Reply</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="isDataLoading">
              <tr v-for="(item, index) in 10" :key="index">
                <td class="placeholder-glow" v-for="no in 4" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(data, index) in tableData" :key="data.id">
                <td @click="openBotDrawer(data.id, index)">
                  {{ data.intent_name }}
                </td>
                <td class="text-wrap w-500 cursor">
                  <p
                    class="mb-0"
                    v-for="(utterances, inx) in data.utterances"
                    :key="inx"
                    @click="InjectTesting(utterances)"
                  >
                    <span v-if="inx == 0 || (inx == 1 && !data.more_status)">
                      <i class="fas fa-arrow-right text-muted me-1 mb-2"></i>
                      {{ utterances }}
                    </span>
                    <span v-if="data.more_status">
                      <i class="fas fa-arrow-right text-muted me-1 mb-2"></i>
                      {{ utterances }}
                    </span>
                  </p>
                  <a
                    @click="data.more_status = !data.more_status"
                    class="text-primary"
                  >
                    {{ data.more_status ? "Less..." : "More..." }}</a
                  >
                </td>
                <td class="text-wrap w-500">
                  <p class="mb-0">
                    {{ data.text_reply }}
                  </p>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <i
                      class="fas fa-microphone-alt fs-5"
                      @click="data.audio_file != '' ? mediaTest(data) : ''"
                      :class="[
                        data.audio_file == '' ? 'text-muted' : 'text-success',
                      ]"
                    ></i>
                    <i
                      class="fas fa-video fs-5 mx-4 fs-4"
                      @click="data.video_file != '' ? mediaTest(data) : ''"
                      :class="[
                        data.video_file == '' ? 'text-muted' : 'text-success',
                      ]"
                    ></i>
                    <i
                      class="fas fa-pencil-alt text-success fs-5"
                      @click="editIntent(data)"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-"
      size="md"
      ref="inject_testing_modal"
      title="Stream Test"
      title-class="font-18"
      headerClass="border-bottom-0 justify-content-center"
      centered
      hide-footer
    >
      <div class="card">
        <div class="card-body text-center">
          <form @submit.prevent="InjectText">
            <div class="form-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="injectObj.session_id"
                placeholder="session id"
                required
              />
            </div>
            <div class="form-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="injectObj.text"
                placeholder="text"
                required
              />
            </div>
            <div class="form-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="injectObj.hotel_id"
                placeholder="hotel_id"
                required
              />
            </div>
            <div
              class="spinner-border spinner-border-primary spinner-primary spinner-border-sm"
              role="status"
              v-show="addLoading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <button class="btn btn-primary" type="submit" v-show="!addLoading">
              Select
            </button>
          </form>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-"
      size="md"
      ref="media_testing_modal"
      title="Media"
      title-class="font-18"
      headerClass="border-bottom-0 justify-content-center"
      centered
      hide-footer
    >
      <div class="card">
        <div class="card-body text-center">
          <div class="row">
            <div class="col-md-12 text-center" v-if="media.audio_file != ''">
              <h5>Audio File</h5>
              <audio controls class="mt-3 w-100">
                <source
                  :src="
                    'https://vod-lex-files.s3.amazonaws.com/' + media.audio_file
                  "
                  type="audio/mp3"
                />
              </audio>
            </div>

            <div class="col-md-12 mt-3" v-if="media.video_file != ''">
              <h5>Video File</h5>
              <video
                width="320"
                height="240"
                controls
                autoplay
                class="mt-3 w-100"
              >
                <source
                  :src="
                    'https://vod-lex-files.s3.amazonaws.com/' + media.video_file
                  "
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Drawer -->
    <Drawer
      @close="addEditIntentDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="addEditIntent">
        <hotelIntentEditDrawer
          :currentProps="intentProps"
          @submitted="intentAddedUpdated"
          @cancelSubmit="addEditIntentDrawer"
          @saveAndAddNew="saveAndAddNewIntent"
        ></hotelIntentEditDrawer>
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.w-400 {
  width: 400px;
}

.w-500 {
  width: 500px;
}
</style>
